// extracted by mini-css-extract-plugin
module.exports = {"addButton":"PermissionsSettings_addButton__W5hmA","footer":"PermissionsSettings_footer__1XHpq"};